import type { CityConfig } from "../city-template/types";

export const kirksvilleMOConfig: CityConfig = {
  city: "Kirksville",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "kirksville-mo",
  route: "/cities/kirksville-mo",
  title: "Emergency Passport Kirksville, MO | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Kirksville, MO — as fast as 24 hours. Serving Adair County and the Truman State University community. A+ BBB rated registered State Dept. courier serving Kirksville, La Plata, Edina, and northeast Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Kirksville, MO",
  heroSubtitle: "Truman State student heading to study abroad in Spain and need a passport fast? AT Still medical rotation overseas with urgent document needs? Northeast Missouri family vacation to Mexico coming up? We help Kirksville residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Kirksville%20Missouri%20Adair%20County%20Truman%20State%20University%20campus%20Pickler%20Memorial%20Library%20red%20brick%20academic%20buildings%20rural%20northeast%20Missouri%20college%20town%20landscape%20green%20rolling%20hills%20farmland%20surrounding%20the%20city%20golden%20hour%20warm%20light%20professional%20drone%20photography%20education%20and%20Heartland%20heritage%20in%20northeast%20Missouri&width=1800&height=700&seq=kirksville-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Kirksville Missouri Truman State University campus and northeast Missouri college town at golden hour",
  geoPosition: "40.1947;-92.5833",
  geoPlacename: "Kirksville, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 380 miles east of Kirksville via US-63/I-55",
  },
  nearbyCitiesZips: [
    { name: "Kirksville", zips: "63501" },
    { name: "La Plata", zips: "63549" },
    { name: "Edina", zips: "63537" },
    { name: "Macon", zips: "63552" },
    { name: "Milan", zips: "63556" },
    { name: "Memphis", zips: "63555" },
    { name: "Lancaster", zips: "63548" },
    { name: "Unionville", zips: "63565" },
    { name: "Brookfield", zips: "64628" },
    { name: "Chillicothe", zips: "64601" },
    { name: "Shelbina", zips: "63468" },
    { name: "Palmyra", zips: "63461" },
    { name: "Hannibal", zips: "63401" },
    { name: "Moberly", zips: "65270" },
    { name: "Ottumwa", zips: "52501" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Adair County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "University & Medical Hub", desc: "Serving Truman State, AT Still University, and northeast Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Fast passport renewal in Hannibal, MO", route: "/cities/hannibal" },
    { name: "Emergency passport help in Quincy, IL", route: "/cities/quincy-il" },
    { name: "Urgent passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Passport courier services in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kirksville remotely via secure courier. We do not have a walk-in office in Kirksville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Adair County, Truman State University students, and northeast Missouri.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Adair County including Kirksville, La Plata, Edina, and the northeast Missouri region",
  serviceAreaIntro: "From the Truman State University campus and the AT Still University of Health Sciences to the historic town square of Kirksville and the rural charm of northeast Missouri, from the agricultural communities of Adair County to the Thousand Hills State Park along Forest Lake — Fast Passport Center serves the entire northeast Missouri region. We regularly help Truman State Bulldogs studying abroad, ATSU medical students on rotations, and Adair County families get their passports fast without the long drive to Chicago, Des Moines, or St. Louis.",
  nearbyCitiesIntro: "We serve all Kirksville neighborhoods including the university district and surrounding areas of La Plata, Edina, Macon, and beyond. If you are anywhere in Adair County, Knox County, Schuyler County, or northeast Missouri, we have you covered.",
  howItWorksIntro: "Most Kirksville travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Kirksville travelers face significant distances to any regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Kirksville and Adair County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Kirksville? Here are the most common ones we hear from northeast Missouri travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kirksville travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "Kirksville, MO",
      rating: 5,
      text: "Truman State study abroad to Barcelona and my passport expired. Fast Passport Center got renewal in 28 hours. From Kirksville to Catalonia in a week. All my classmates' jaws dropped. Best service on campus!",
      service: "Passport Renewal",
    },
    {
      name: "Dr. James T.",
      location: "La Plata, MO",
      rating: 5,
      text: "ATSU medical conference in Tokyo in 4 days. Fast Passport Center handled my expedited passport in 26 hours. The dedicated agent understood the urgency. Northeast Missouri's hidden gem for passport help!",
      service: "Emergency Passport",
    },
    {
      name: "Rebecca S.",
      location: "Kirksville, MO",
      rating: 5,
      text: "Family trip to Canada — my daughter needed a first passport. Fast Passport Center guided us through the child passport process and had it in 4 days. Adair County families, this is the only passport service you need!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "kirksville-1",
      name: "Kirksville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 N Franklin St",
      city: "Kirksville",
      state: "MO",
      zip: "63501",
      phone: "(660) 665-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Kirksville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kirksville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "kirksville-2",
      name: "Adair County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "106 W Washington St",
      city: "Kirksville",
      state: "MO",
      zip: "63501",
      phone: "(660) 665-2552",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Kirksville Courthouse",
      website: "https://www.adaircountymo.com",
      websiteLabel: "Adair County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "kirksville-3",
      name: "Macon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 Rouleau St",
      city: "Macon",
      state: "MO",
      zip: "63552",
      phone: "(660) 385-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles south of Kirksville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Macon County area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "kirksville-4",
      name: "Edina Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "113 N Main St",
      city: "Edina",
      state: "MO",
      zip: "63537",
      phone: "(660) 397-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles east of Kirksville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Knox County area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "kirksville-5",
      name: "Milan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "204 E 2nd St",
      city: "Milan",
      state: "MO",
      zip: "63556",
      phone: "(660) 265-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "28 miles west of Kirksville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sullivan County area. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Kirksville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Adair County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Kirksville students and residents show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Truman State and ATSU families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Northeast Missouri travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Kirksville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kirksville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Kirksville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Kirksville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Kirksville?", a: "Fast Passport Center offers fast passport renewal in Kirksville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both include full document review and a dedicated agent — especially valuable for Truman State students on tight semester schedules." },
    { q: "What is the closest passport agency to Kirksville?", a: "The nearest regional passport agency to Kirksville is the Chicago Passport Agency, approximately 380 miles east via US-63/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Kirksville without any in-person agency visit." },
    { q: "Do you serve Truman State and AT Still University students?", a: "Absolutely. Fast Passport Center proudly serves Truman State University and AT Still University students needing urgent passports for study abroad programs, international medical rotations, and academic conferences. Our courier service handles everything — you focus on your studies." },
    { q: "Can I get a same-day passport appointment near Kirksville?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 5+ hour drive from Kirksville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Adair County residents." },
    { q: "Do you serve the entire northeast Missouri region?", a: "Absolutely. Fast Passport Center serves the entire northeast Missouri region including Kirksville, La Plata, Edina, Macon, Milan, and surrounding counties. Our courier service works seamlessly from any address in Adair, Knox, Schuyler, or Macon counties." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Kirksville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Can I expedite a child passport in Kirksville?", a: "Yes. Fast Passport Center expedites child passports in Kirksville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Adair County and university families through the entire process." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Kirksville", address: "2401 N Baltimore St, Kirksville, MO 63501", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Kirksville", address: "1705 N Baltimore St, Kirksville, MO 63501", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Macon", address: "705 Enterprise Rd, Macon, MO 63552", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Ottumwa, IA", address: "327 W Main St, Ottumwa, IA 52501", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Kirksville License Office",
      address: "121 W Jefferson St, Kirksville, MO 63501",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Kirksville residents and Truman State students.",
      featured: true,
    },
    {
      name: "Missouri DOR — Macon License Office",
      address: "101 Washington St, Macon, MO 63552",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Macon County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Hannibal License Office",
      address: "1201 Broadway St, Hannibal, MO 63401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Marion County and northeast Missouri. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IRK",
      name: "Kirksville Regional Airport",
      distance: "5 miles south of Kirksville",
      address: "25000 Airport Rd, Kirksville, MO 63501",
      note: "Regional airport with connecting flights to St. Louis via Cape Air. About 10 minutes from downtown Kirksville.",
      flightUrl: "https://www.kirksvillecity.com/airport",
      flightLabel: "IRK Airport",
      featured: true,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "165 miles southwest of Kirksville",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with worldwide connections. About 2 hours 45 minutes from Kirksville.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "150 miles northwest of Kirksville",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Major Iowa airport with direct flights nationwide. About 2 hours 30 minutes from Kirksville.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
  ],
};